import { appBus } from '..'

export function selectBackgroundMusic(track: number, startPlay = true) {
  appBus.commands.emit('backgroundMusic.select', { track, startPlay })
}
